var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9595 1.85986H8.15955C4.6194 1.85986 1.74951 4.72749 1.74951 8.26488C1.74951 11.8023 4.6194 14.6699 8.15955 14.6699H16.9595C20.4996 14.6699 23.3695 11.8023 23.3695 8.26488C23.3695 4.72749 20.4996 1.85986 16.9595 1.85986Z",
    fill: "#709DA7",
    stroke: "#FFFEF6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4496 5.6499L17.6896 10.8799",
    stroke: "#FFFEF6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4496 5.6499L7.21948 10.8799",
    stroke: "#FFFEF6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4595 5.6499V17.3699",
    stroke: "#FFFEF6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55957 19.6802H18.3595",
    stroke: "#FFFEF6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload3);
export default __webpack_public_path__ + "static/media/upload3.6c6a9e3e6869f5c96ccbedbcfce4881c.svg";
export { ForwardRef as ReactComponent };